module.exports = __webpack_public_path__ + "img/clock-logo.2b2ddd9c.png";